<template>
  <div class="flex flex-wrap justify-center -m-2">
    <div class="m-2">
      <label><input type="checkbox" v-model="selectAll"><div class="label"># すべて</div></label>
    </div>
    <div class="m-2" v-for="(category, index) of categories" :key="index">
      <label><input type="checkbox" v-model="selectedCategories" :value="String(category.id)"><div class="label"># {{category.name}}</div></label>
    </div>
  </div>
</template>
<style lang="sass" scoped>
input
  @apply hidden
.label
  @apply cursor-pointer bg-gray-200 rounded-full text-xs leading-none py-3 px-6
  input:checked + &
    @apply bg-secondary text-white
</style>
<script>
export default {
  props: {
    value: { type: Array, required: true },
    categories: { type: Array, required: true }
  },
  computed: {
    selectAll: {
      get() { return this.value.length < 1 },
      set(v) { this.$emit('input', []) }
    },
    selectedCategories: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    }
  }
}
</script>
